import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-ccs-help-information',
  templateUrl: './ccs-help-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpInformationComponent {}
